import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, take, tap } from 'rxjs/operators';

import { Block } from '@core/models/block/block.model';
import { ApiBlockService } from '@core/services/api/api-block.service';
import { DOCUMENT } from '@angular/common';
import { BlockActionModel } from '@core/models';
import { MixedObject } from '@core/interfaces/mixed-object';
import { StyleService } from '@core/services/common/styles/style.service';
import { MediaQueryBuilder } from '@core/services/common/styles/media-query-builder';

@Injectable()
export class PopupService {
  private _popup$ = new Subject<Block>();
  public popup$ = this._popup$.asObservable().pipe(distinctUntilChanged());
  public onClose$ = new Subject<void>();

  constructor(private api: ApiBlockService,
              private styleService: StyleService,
              @Inject(DOCUMENT) private document: Document) {
  }

  /**
   * Tresc popupu pobieramy dopiero tutaj, wiec wybor z konfiguratora ceny musi dojsc razem
   * z zadaniem — inaczej backend serializuje prace od nowa i popup pokazuje cene klasyczna
   * zamiast kwoty wybranego wariantu.
   */
  openModal(actionData: MixedObject, model: BlockActionModel, variantId: number | null = null) {
    this.api.get(actionData.blockId, true, model, variantId)
      .pipe(
        take(1),
        tap((block) => this.createStyles(block)))
      .subscribe((block) => {
        this._popup$.next(block);
        this.document.body.style.overflow = 'hidden';
      });
  }

  close() {
    this._popup$.next(null);
    this.onClose$.next();
    this.document.body.style.removeProperty('overflow');
  }

  private createStyles(block: Block) {
    const blocksStyles = MediaQueryBuilder.build([block]);
    StyleService.bodyStyles.push(blocksStyles);
    this.styleService.setStyles();
  }
}
